import React, { useState, useEffect } from 'react';
import {
  Box, Typography, Card, CardContent, Grid, Select, MenuItem, FormControl,
  InputLabel, Avatar, Chip, Dialog, DialogTitle, DialogContent,
  IconButton, LinearProgress, Button, DialogActions, Paper,
  TextField, Tooltip, Modal, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, FormControlLabel, Switch
} from '@mui/material';
import {
  Group, CheckCircle, Cancel, Timer, Close, Event, EventAvailable,
  EventBusy, AccessTime, KeyboardArrowLeft, KeyboardArrowRight, AccessAlarm,
  Alarm, AlarmOff, LocationOn, LocationOff, Clear
} from '@mui/icons-material';
import axios from 'axios';
import {axiosInstance, localAxiosGet, localAxiosToken } from '../../../Axios/axios';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { Loader } from '../../../components/loade';
import { alpha } from '@mui/material/styles';
import EmployeeAttendanceCalendar from '../../../components/MyAttendance';
import TokenExpirePopup from '../../../components/TokenExpirePopup';
import { useNavigate } from 'react-router-dom';
import ViewAllAttendance from './ViewAllAttendance';

export const AttendancePage = () => {
  const [selectedProject, setSelectedProject] = useState(null);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const accessToken = localStorage.getItem('accessToken');
  const userId = localStorage.getItem('userId')
  const [projectNamesWithId, setProjectNamesWithId] = useState([]);
  const [todayAttendanceOverview, setTodayAttendanceOverview] = useState({});
  const [selectedDate, setSelectedDate] = useState(dayjs().startOf('month'));
  const [employees, setEmployees] = useState([])
  const [selectedStatus, setSelectedStatus] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [attendanceRecords, setAttendanceRecords] = useState([]);
  const [isMyAttendanceopen, setIsMyAttendanceOpen] = useState(false);
  const [isUserId, setIsUserId] = useState(null);
  const [viewAllToggle, setViewAllToggle] = useState(true);
  const [viewAllDate, setViewAllDate] = useState(dayjs());
  const [viewAllStatusFilter, setViewAllStatusFilter] = useState('');
  const [isViewAllLoading, setIsViewAllLoading] = useState(false);
  const [inOfficeCheckIn, setInOfficeCheckIn] = useState('');
  const [inOfficeCheckOut, setInOfficeCheckOut] = useState('');
  const [holidays, setHolidays] = useState([]);
  const [hasActiveFilters, setHasActiveFilters] = useState(false);
  const [paginationInfo, setPaginationInfo] = useState({
    page: 1,
    limit: 10,
    totalRecords: 0,
    totalPages: 1
  });

  const [selectedMonth] = useState(dayjs());
  const [monthlyAttendance, setMonthlyAttendance] = useState({});
  const [monthlyOverview, setMonthlyOverview] = useState({
    present: 0,
    absent: 0,
    late: 0,
    weekend: 0
  });
  const [openTokenExpirePopup, setOpenTokenExpirePopup] = useState(false);
  const navigate = useNavigate();

  const handleInOfficeCheckInChange = (event) => {
    setInOfficeCheckIn(event.target.value);
  };

  const handleInOfficeCheckOutChange = (event) => {
    setInOfficeCheckOut(event.target.value);
  };


  const fetchHolidays = async () => {
    const locationId = localStorage.getItem('locationId');
    const organizationId = localStorage.getItem('organizationId');
    const year = selectedDate.year();
    const month = selectedDate.month() + 1;
    try {
      const response = await axiosInstance(localAxiosGet(
        `/organization/getAllHolidaysByYearAndMonth?year=${year}&organization_id=${organizationId}&location_id=${locationId}&month=${month}`,
        accessToken
      ));
      if (response.data && response.data.message && response.data.message.holidays) {
        setHolidays(response.data.message.holidays);
      }
    } catch (error) {
      console.error("Error fetching holidays:", error);
    }
  };
  useEffect(() => {
    if (!viewAllToggle && selectedProject) {
      fetchTeamMembersList(selectedProject, paginationInfo.page);
      // setPaginationInfo
    }
  }, [viewAllDate, selectedProject, viewAllToggle, selectedDate]);



  const handleViewAllToggle = () => {
    setIsViewAllLoading(true);
    const newToggleState = !viewAllToggle;
    setViewAllToggle(newToggleState);

    setViewAllStatusFilter('');
    setInOfficeCheckIn('');
    setInOfficeCheckOut('');


    if (newToggleState) {
      fetchAttendanceOverview();
    } else {

      setTodayAttendanceOverview({
        totalEmployees: 0,
        presentToday: 0,
        absentToday: 0,
        lateArrivalToday: 0,
        leaveCount: 0
      });


      if (selectedProject && selectedProject !== "Select Project") {
        fetchTeamMembersList(selectedProject);
      }
    }

    setTimeout(() => {
      setIsViewAllLoading(false);
    }, 1000);
  };

  const handleViewAllDateChange = (newDate) => {

    if (dayjs(newDate).isValid()) {
      setViewAllDate(newDate);


      if (viewAllToggle) {
        fetchAttendanceOverview();
      }
    } else {
      console.error("Invalid date selected:", newDate);
    }
  };

  const handleViewAllStatusFilterChange = (event) => {
    setViewAllStatusFilter(event.target.value);
  };

  const handleCloseTokenExpirePopup = () => {
    setOpenTokenExpirePopup(false);
    navigate('/');
  };

  const handleProjectOnChange = (e) => {
    const newProjectId = e.target.value;
    setSelectedProject(newProjectId);

    setPaginationInfo(prev => ({ ...prev, page: 1 }));
    fetchTeamMembersList(newProjectId, 1);
  };

  const handleDateChange = (newDate) => {

    if (dayjs(newDate).isValid()) {
      setSelectedDate(newDate.startOf('month'));
      setPaginationInfo(prev => ({ ...prev, page: 1 }));

      if (!viewAllToggle && selectedProject) {
        fetchTeamMembersList(selectedProject, 1, newDate.startOf('month').format('MMMM YYYY'));
      }
    } else {
      console.error("Invalid date selected:", newDate);
    }
  };

  const handleMyAttendanceButton = () => {
    setIsMyAttendanceOpen(true);
  }

  const handleMyAttendanceButtonClose = () => {
    setIsMyAttendanceOpen(false);
  }


  const handlePageChange = (newPage) => {
    setPaginationInfo(prev => ({ ...prev, page: newPage }));
    fetchTeamMembersList(selectedProject, newPage);
  };

  useEffect(() => {
    fetchAttendanceOverview();
    fetchProjectData();
  }, [accessToken, userId]);



  const fetchAttendanceOverview = async (managerId = userId, summaryData = null) => {
    try {

      if (summaryData) {
        setTodayAttendanceOverview({
          totalEmployees: summaryData.total_employees || summaryData.totalEmployees || 0,
          presentToday: summaryData.present || 0,
          absentToday: summaryData.absent || 0,
          lateArrivalToday: summaryData.late || 0,
          leaveCount: summaryData.leave || 0
        });
        return;
      }


      const formattedDate = dayjs().format('MM/DD/YYYY');

      const response = await axiosInstance(localAxiosGet(
        `/organization/getAllEmployeesUnderManagerAttendance?Date=${formattedDate}&manager_id=${managerId}&page=1&limit=10`,
        accessToken
      ));

      // console.log('Attendance overview response:', response.data);

      if (response.data.status === 'SUCCESS' && response.data.message && response.data.message.summary) {
        const summaryData = {
          totalEmployees: response.data.message.summary.total_employees || 0,
          presentToday: response.data.message.summary.present || 0,
          absentToday: response.data.message.summary.absent || 0,
          lateArrivalToday: response.data.message.summary.late || 0,
          leaveCount: response.data.message.summary.leave || 0
        };

        // console.log('Mapped summary data:', summaryData);
        setTodayAttendanceOverview(summaryData);
      } else {
        console.error('Invalid response format or missing summary data:', response.data);
      }
    } catch (error) {
      console.log('Error in fetching Todays Attendance Overview', error);
      if (error.response && error.response.status === 403) {
        setOpenTokenExpirePopup(true);
      }
    }
  };

  const fetchProjectData = async () => {
    try {
      const projectResponse = await axiosInstance(localAxiosGet(`/project/getProjectsBySupervisorId/${userId}`, accessToken));
      const projectNamesDetails = projectResponse.data.message.data.map((project) => ({
        id: project.id,
        name: project.project_title,
        priority: project.priority
      }))
      setProjectNamesWithId(projectNamesDetails);
    } catch (error) {
      console.error('Error while fetching project data', error);
    }
  }

  const selectedMonthYearFormatted = selectedDate.format('MMMM YYYY');

  const handleEmployeeClick = (employee) => {
    setSelectedEmployee(employee);
    fetchAttendanceData(employee.user_id);
    setOpenDialog(true);
  };

  const handleStatusChange = (event) => {
    setSelectedStatus(event.target.value);
  };

  const monthKey = selectedDate.format('YYYY-MM');
  const selectedMonthFormatted = selectedDate.format('MMMM');

  const filteredAttendance = Object.entries(monthlyAttendance)
    .map(([date, details]) => ({ date, ...details }))
    .filter(day => selectedStatus === '' || day.status?.toLowerCase() === selectedStatus.toLowerCase())
    .sort((a, b) => parseInt(a.date) - parseInt(b.date));

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'present':
        return '#4caf50';
      case 'absent':
        return '#f44336';
      case 'latearrival':
      case 'late':
        return '#ff9800';
      case 'leave':
        return '#2196f3';
      case 'weekend':
        return '#9e9e9e';
      default:
        return '#9e9e9e';
    }
  };

  const getStatusIcon = (status) => {
    switch (status?.toLowerCase()) {
      case 'present':
        return <EventAvailable fontSize="small" />;
      case 'absent':
        return <EventBusy fontSize="small" />;
      case 'latearrival':
      case 'late':
        return <AccessTime fontSize="small" />;
      case 'leave':
        return <AlarmOff fontSize="small" />;
      case 'weekend':
        return <Event fontSize="small" />;
      default:
        return <Event fontSize="small" />;
    }
  };

  const formatStatus = (status) => {
    if (status === 'LateArrival') {
      return 'Late Arrival';
    }
    return status;
  };

  const statusOptions = [
    { value: '', label: 'All' },
    { value: 'Present', label: 'Present' },
    { value: 'Absent', label: 'Absent' },
    { value: 'LateArrival', label: 'Late' },
    { value: 'Leave', label: 'Leave' },
    { value: 'Holiday', label: 'Holiday' },
  ];
  const daysInMonth = selectedDate.daysInMonth();
  const daysArray = Array.from({ length: daysInMonth }, (_, i) => {
    const dayNumber = (i + 1).toString();
    return filteredAttendance.find(item => item.date === dayNumber) || { date: dayNumber, status: 'default' };
  });

  const getPriorityColor = (priority) => {
    switch (priority?.toLowerCase()) {
      case 'high':
        return '#f44336';
      case 'medium':
        return '#ff9800';
      case 'low':
        return '#4caf50';
      default:
        return '#9e9e9e';
    }
  };

  const getFilteredEmployees = () => {
    let filtered = [...employees];
    if (selectedProject !== 'all') {
      filtered = filtered.filter(emp => emp.project === projectNamesWithId.find(p => p.id === selectedProject)?.name);
    }
    return filtered;
  };

  const fetchTeamMembersList = async (projectId = selectedProject, page = paginationInfo.page, month = selectedMonthYearFormatted) => {
    setIsLoading(true);


    const formattedDate = dayjs(viewAllDate).isValid()
      ? viewAllDate.format('YYYY-MM-DD')
      : dayjs().format('YYYY-MM-DD');

    const payload = {
      viewType: "Project Wise",
      month: month,
      project_id: projectId,
      page: page,
      limit: paginationInfo.limit,
      date: formattedDate
    };

    try {
      const response = await axiosInstance(localAxiosToken('/organization/filterAttendance', payload, accessToken));

      setEmployees(response.data.message.userRecords || []);


      if (response.data.message.summary) {
        setTodayAttendanceOverview({
          totalEmployees: response.data.message.summary.totalEmployees || 0,
          presentToday: response.data.message.summary.present || 0,
          absentToday: response.data.message.summary.absent || 0,
          lateArrivalToday: response.data.message.summary.late || 0,
          leaveCount: response.data.message.summary.leave || 0
        });
      }

      if (response.data.message.pagination) {
        setPaginationInfo({
          page: response.data.message.pagination.page || 1,
          limit: response.data.message.pagination.limit || 10,
          totalRecords: response.data.message.pagination.totalRecords || 0,
          totalPages: response.data.message.pagination.totalPages || 1
        });
      }
    } catch (error) {
      console.log('Error in fetching team members list', error);

      setTodayAttendanceOverview({
        totalEmployees: 0,
        presentToday: 0,
        absentToday: 0,
        lateArrivalToday: 0,
        leaveCount: 0
      });
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 2000);
    }
  };

  let presentCount = 0;
  let absentCount = 0;
  let lateCount = 0;
  let weekendCount = 0;

  useEffect(() => {
    fetchHolidays();
  }, [selectedDate]);

  const fetchAttendanceData = async (employeeId = selectedEmployee?.user_id) => {
    try {
      const monthYearString = selectedDate.format('MMMM');
      setMonthlyAttendance({});
      setMonthlyOverview({ present: 0, absent: 0, late: 0, weekend: 0, leave: 0 });

      const [attendanceResponse] = await Promise.all([
        axiosInstance(localAxiosGet(
          `/organization/getAttendanceByEmployeeIdByStatus?employee_id=${userId}&month=${monthYearString}`,
          accessToken
        )),

      ])
      // console.log('Attendance data response:', response.data);

      const transformedData = {};
      let presentCount = 0;
      let absentCount = 0;
      let lateCount = 0;
      let weekendCount = 0;
      let leaveCount = 0;

      if (attendanceResponse.data && attendanceResponse.data.message && attendanceResponse.data.message.attendanceRecords) {
        attendanceResponse.data.message.attendanceRecords.forEach(item => {
          const day = dayjs(item.date).format('D');
          const dayDate = dayjs(item.date);
          const isWeekend = dayDate.day() === 0 || dayDate.day() === 6;

          if (isWeekend) {
            weekendCount++;
          }

          transformedData[day] = {
            date: item.date,
            inTime: item.check_in ? dayjs(item.check_in).format('HH:mm') : '',
            outTime: (item.check_out === null) ? '00:00' : (item.check_out ? dayjs(item.check_out).format('HH:mm') : ''),
            status: isWeekend ? 'Weekend' : item.status,
            inOffice: item.office_premises?.check_in?.in_office === 'yes',
            outOffice: item.office_premises?.check_out?.in_office === 'yes',
          };

          if (item.status === 'Present') {
            presentCount++;
          } else if (item.status === 'Absent') {
            absentCount++;
          } else if (item.status === 'LateArrival') {
            lateCount++;
          } else if (item.status === 'Leave') {
            leaveCount++;
          }
        });

        setMonthlyAttendance(transformedData);
        setMonthlyOverview({
          present: presentCount,
          absent: absentCount,
          late: lateCount,
          weekend: weekendCount,
          leave: leaveCount
        });
      }
    } catch (error) {
      console.error("Error fetching attendance data:", error);
      setMonthlyAttendance({});
      setMonthlyOverview({ present: 0, absent: 0, late: 0, weekend: 0, leave: 0 });
    }
  };




  useEffect(() => {
    if (selectedEmployee && openDialog) {
      fetchAttendanceData();
    }
  }, [selectedEmployee, openDialog]);



  const checkActiveFilters = () => {
    if (viewAllToggle) {
      const hasDateFilter = !viewAllDate.isSame(dayjs(), 'day');
      const hasStatusFilter = viewAllStatusFilter && viewAllStatusFilter !== 'All';
      const hasCheckInFilter = inOfficeCheckIn && inOfficeCheckIn !== 'All';
      const hasCheckOutFilter = inOfficeCheckOut && inOfficeCheckOut !== 'All';

      return hasDateFilter || hasStatusFilter || hasCheckInFilter || hasCheckOutFilter;
    } else {
      const hasProjectFilter = selectedProject && selectedProject !== null;
      const hasDateFilter = !selectedDate.isSame(dayjs().startOf('month'), 'month');

      return hasProjectFilter || hasDateFilter;
    }
  }

  useEffect(() => {
    setHasActiveFilters(checkActiveFilters());
  }, [viewAllToggle, viewAllDate, viewAllStatusFilter, inOfficeCheckIn, inOfficeCheckOut, selectedProject, selectedDate])

  const handleClearFilters = () => {
    if (viewAllToggle) {
      setViewAllDate(dayjs());
      setViewAllStatusFilter('');
      setInOfficeCheckIn('');
      setInOfficeCheckOut('');

      fetchAttendanceOverview(); // Fetch default data
    } else {
      setSelectedProject(null);
      setSelectedDate(dayjs().startOf('month'));
      setEmployees([]);

    }
  };

  const renderPagination = () => {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', p: 2 }}>
        <Box sx={{ mr: 2 }}>
          <Typography variant="body2" color="text.secondary">
            Page {paginationInfo.page} of {paginationInfo.totalPages}
            ({paginationInfo.totalRecords} total records)
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            size="small"
            variant="outlined"
            disabled={paginationInfo.page <= 1}
            onClick={() => handlePageChange(paginationInfo.page - 1)}
            sx={{
              minWidth: 'auto',
              p: '4px 8px',
              borderColor: '#1a237e',
              color: '#1a237e',
              '&:hover': { bgcolor: alpha('#1a237e', 0.1) }
            }}
          >
            <KeyboardArrowLeft fontSize="small" />
          </Button>
          <Button
            size="small"
            variant="outlined"
            disabled={paginationInfo.page >= paginationInfo.totalPages}
            onClick={() => handlePageChange(paginationInfo.page + 1)}
            sx={{
              minWidth: 'auto',
              p: '4px 8px',
              borderColor: '#1a237e',
              color: '#1a237e',
              '&:hover': { bgcolor: alpha('#1a237e', 0.1) }
            }}
          >
            <KeyboardArrowRight fontSize="small" />
          </Button>
        </Box>
      </Box>
    );
  };

  return (
    <Box sx={{ p: 3, background: '#f5f5f5' }}>
      {(isLoading || isViewAllLoading) && <Loader />}
      <Box sx={{
        mb: 4,
        p: 4,
        borderRadius: 2,
        background: 'linear-gradient(135deg, #1a237e 0%, #0d47a1 100%)',
        color: 'white',
        boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center'
      }}>
        <Box sx={{}}>
          <Typography variant="h4" sx={{ fontWeight: 600 }}>
            Attendance Overview
          </Typography>
          <Typography variant="subtitle1" sx={{ opacity: 0.8 }}>
            Monitor and manage employee attendance
          </Typography>
        </Box>
        <Button
          variant="contained"
          sx={{
            backgroundColor: 'white',
            color: '#0d47a1',
            fontWeight: 'bold',
            borderRadius: 1,
            boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
            '&:hover': {
              backgroundColor: '#f0f0f0',
            },
            padding: '8px 16px',
            textTransform: 'none'
          }}
          onClick={handleMyAttendanceButton}
        >
          My Attendance
        </Button>
      </Box>
      <Grid container spacing={3} sx={{ mb: 4 }}>
        {[
          {
            title: 'Total Employees',
            count: todayAttendanceOverview.totalEmployees,
            icon: <Group />,
            color: '#2196f3',
            gradient: 'linear-gradient(135deg, #2196f3 0%, #1976d2 100%)'
          },
          {
            title: 'Present Today',
            count: todayAttendanceOverview.presentToday,
            icon: <CheckCircle />,
            color: '#4caf50',
            gradient: 'linear-gradient(135deg, #4caf50 0%, #2e7d32 100%)'
          },
          {
            title: 'Absent Today',
            count: todayAttendanceOverview.absentToday,
            icon: <Cancel />,
            color: '#f44336',
            gradient: 'linear-gradient(135deg, #f44336 0%, #c62828 100%)'
          },
          {
            title: 'Late Arrivals',
            count: todayAttendanceOverview.lateArrivalToday,
            icon: <Timer />,
            color: '#ff9800',
            gradient: 'linear-gradient(135deg, #ff9800 0%, #f57c00 100%)'
          },
          {
            title: 'Leave Today',
            count: todayAttendanceOverview.leaveCount,
            icon: <AlarmOff />,
            color: '#9c27b0',
            gradient: 'linear-gradient(135deg, #9c27b0 0%, #6a1b9a 100%)'
          }
        ].map((stat, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card sx={{
              background: stat.gradient,
              color: 'white',
              transform: 'translateY(0)',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-5px)',
                boxShadow: '0 8px 25px rgba(0,0,0,0.2)'
              }
            }}>
              <CardContent>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <Box>
                    <Typography variant="h3" sx={{ fontWeight: 'bold' }}>
                      {stat.count}
                    </Typography>
                    <Typography variant="body1">
                      {stat.title}
                    </Typography>
                  </Box>
                  <Avatar sx={{
                    bgcolor: 'rgba(255,255,255,0.2)',
                    width: 56,
                    height: 56
                  }}>
                    {stat.icon}
                  </Avatar>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Box sx={{
        mb: 4,
        p: 3,
        backgroundColor: 'white',
        borderRadius: 2,
        boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap'
      }}>
        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
          {!viewAllToggle ? (
            <>
              <FormControl sx={{ minWidth: 200 }} variant="outlined">
                <InputLabel id="project-name-label">Project Name</InputLabel>
                <Select
                  labelId="project-name-label"
                  value={selectedProject}
                  onChange={(e) => handleProjectOnChange(e)}
                  label="Project Name"
                  sx={{
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: 'rgba(26, 35, 126, 0.2)',
                    },
                    '&:hover .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#1a237e',
                    },
                    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#1a237e',
                    },
                  }}
                >
                  <MenuItem value="Select Project">Select Project</MenuItem>
                  {projectNamesWithId.map(project => (
                    <MenuItem key={project.id} value={project.id}>
                      {project.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Select Date"
                  value={selectedDate}
                  onChange={handleDateChange}
                  maxDate={dayjs()}
                  format='DD/MM/YYYY'
                  slotProps={{ textField: { size: "small" } }}
                />
              </LocalizationProvider>
            </>
          ) : (
            <>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Select Date"
                  value={viewAllDate}
                  onChange={handleViewAllDateChange}
                  maxDate={dayjs()}
                  format='DD/MM/YYYY'
                  slotProps={{ textField: { size: "small" } }}
                />
              </LocalizationProvider>
              <FormControl variant="outlined" size="small" sx={{ minWidth: 150 }}>
                <InputLabel id="view-all-status-filter-label">Status Filter</InputLabel>
                <Select
                  labelId="view-all-status-filter-label"
                  id="view-all-status-filter"
                  value={viewAllStatusFilter}
                  onChange={handleViewAllStatusFilterChange}
                  label="Status Filter"
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Present">Present</MenuItem>
                  <MenuItem value="Absent">Absent</MenuItem>
                  <MenuItem value="LateArrival">Late Arrival</MenuItem>
                  <MenuItem value="Leave">Leave</MenuItem>
                </Select>
              </FormControl>
              <FormControl variant="outlined" size="small" sx={{ minWidth: 180 }}>
                <InputLabel id="in-office-check-in-label">Office Check-In</InputLabel>
                <Select
                  labelId="in-office-check-in-label"
                  id="in-office-check-in"
                  value={inOfficeCheckIn}
                  onChange={handleInOfficeCheckInChange}
                  label="Office Check-In"
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="yes">yes</MenuItem>
                  <MenuItem value="no">no</MenuItem>
                </Select>
              </FormControl>

              <FormControl variant="outlined" size="small" sx={{ minWidth: 180 }}>
                <InputLabel id="in-office-check-out-label">Office Check-Out</InputLabel>
                <Select
                  labelId="in-office-check-out-label"
                  id="in-office-check-out"
                  value={inOfficeCheckOut}
                  onChange={handleInOfficeCheckOutChange}
                  label="Office Check-Out"
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="yes">yes</MenuItem>
                  <MenuItem value="no">no</MenuItem>
                </Select>
              </FormControl>
            </>
          )}
          {hasActiveFilters && (
            <Button
              variant="outlined"
              color="secondary"
              startIcon={<Clear />}
              onClick={handleClearFilters}
              sx={{
                borderColor: '#f44336',
                color: '#f44336',
                '&:hover': {
                  borderColor: '#d32f2f',
                  backgroundColor: alpha('#f44336', 0.04)
                },

              }}
            >
              Clear
            </Button>
          )}
        </Box>
        <Box sx={{ display: 'flex', gap: 1, }}>

          <FormControlLabel
            control={
              <Switch
                checked={viewAllToggle}
                onChange={handleViewAllToggle}
                color="primary"
              />
            }
            label="View All"
            labelPlacement="start"
            sx={{ m: 0 }}
          />
        </Box>

      </Box>
      {viewAllToggle && (
        <ViewAllAttendance
          viewAll={true}
          selectedDate={viewAllDate}
          statusFilter={viewAllStatusFilter}
          onEmployeeClick={handleEmployeeClick}
          accessToken={accessToken}
          inOfficeCheckIn={inOfficeCheckIn}
          inOfficeCheckOut={inOfficeCheckOut}
          onInOfficeCheckInChange={handleInOfficeCheckInChange}
          onInOfficeCheckOutChange={handleInOfficeCheckOutChange}
          onManagerSelect={(managerId, summaryData) => fetchAttendanceOverview(managerId, summaryData)}
          onClearFilters={handleClearFilters}
          hasActiveFilters={hasActiveFilters}
          holidaysList={holidays}
        />
      )}
      {!viewAllToggle && (
        <TableContainer component={Paper} sx={{
          mb: 4,
          borderRadius: 2,
          boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
          overflow: 'hidden'
        }}>
          <Table sx={{ minWidth: 650 }} aria-label="employee attendance table">
            <TableHead sx={{
              background: 'linear-gradient(135deg, #1a237e 0%, #0d47a1 100%)',
            }}>
              <TableRow>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Employee</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Designation</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Project</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Attendance Rate</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Present</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Absent</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Late</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Leave</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {employees.map((employee) => {
                const projectDetail = projectNamesWithId.find(p => p.id === employee.project_id);
                const projectName = projectDetail ? projectDetail.name : 'N/A';
                const projectPriority = projectDetail ? projectDetail.priority : null;
                return (
                  <TableRow
                    key={employee.id || employee.user_id}
                    hover
                    onClick={() => handleEmployeeClick(employee)}
                    sx={{
                      cursor: 'pointer',
                      '&:hover': {
                        backgroundColor: alpha('#1a237e', 0.04),
                      }
                    }}
                  >
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <Avatar
                          sx={{
                            bgcolor: '#1a237e',
                            width: 40,
                            height: 40,
                            fontSize: '1rem'
                          }}
                        >
                          {employee.name ? employee.name.charAt(0).toUpperCase() : ''}
                        </Avatar>
                        <Typography variant="body1">{employee.name}</Typography>
                      </Box>
                    </TableCell>
                    <TableCell>{employee.designation}</TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        label={projectName}
                        sx={{
                          bgcolor: projectPriority ? `${getPriorityColor(projectPriority)}15` : '#e0e0e0',
                          color: projectPriority ? getPriorityColor(projectPriority) : '#757575',
                          borderRadius: '12px',
                          p: '4px'
                        }}
                      />
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                        <LinearProgress
                          variant="determinate"
                          value={parseFloat(employee.attendance_rate)}
                          sx={{
                            width: 100,
                            height: 8,
                            borderRadius: 4,
                            bgcolor: '#e0e0e0',
                            '& .MuiLinearProgress-bar': {
                              background: `linear-gradient(90deg,
                          ${parseFloat(employee.attendance_rate) > 90 ? '#4caf50' :
                                  parseFloat(employee.attendance_rate) > 80 ? '#ff9800' : '#f44336'} 0%,
                          ${parseFloat(employee.attendance_rate) > 90 ? '#2e7d32' :
                                  parseFloat(employee.attendance_rate) > 80 ? '#f57c00' : '#c62828'} 100%)`
                            }
                          }}
                        />
                        <Typography variant="body2">
                          {employee.attendance_rate}
                        </Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        icon={<CheckCircle fontSize="small" />}
                        label={employee.present_days}
                        sx={{ bgcolor: '#4caf5015', color: '#4caf50' }}
                      />
                    </TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        icon={<Cancel fontSize="small" />}
                        label={employee.absent_days}
                        sx={{ bgcolor: '#f4433615', color: '#f44336' }}
                      />
                    </TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        icon={<Timer fontSize="small" />}
                        label={employee.late_arrivals}
                        sx={{ bgcolor: '#ff980015', color: '#ff9800' }}
                      />
                    </TableCell>
                    <TableCell>
                      <Chip
                        size="small"
                        icon={<AlarmOff fontSize="small" />}
                        label={employee.leave_days}
                        sx={{ bgcolor: '#9c27b015', color: '#9c27b0' }}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
              {employees.length === 0 && (
                <TableRow>
                  <TableCell colSpan={8} align="center" sx={{ py: 3 }}>
                    <Typography variant="body1" color="text.secondary">
                      No employees found for the selected project
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          {paginationInfo.totalRecords > 0 && renderPagination()}
        </TableContainer>
      )}
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            overflow: 'hidden'
          }
        }}
      >
        {selectedEmployee && (
          <>
            <DialogTitle sx={{
              background: 'linear-gradient(135deg, #1a237e 0%, #0d47a1 100%)',
              color: 'white',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              p: 3
            }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Avatar
                  sx={{
                    bgcolor: 'rgba(255,255,255,0.2)',
                    width: 50,
                    height: 50
                  }}
                >
                  {selectedEmployee.name ? selectedEmployee.name.charAt(0).toUpperCase() : ''}
                </Avatar>
                <Box>
                  <Typography variant="h6">{selectedEmployee.name}</Typography>
                  <Typography variant="body2" sx={{ opacity: 0.8 }}>
                    {selectedEmployee.designation}  {selectedEmployee.project}
                  </Typography>
                </Box>
              </Box>
              <IconButton
                onClick={() => setOpenDialog(false)}
                sx={{ color: 'white' }}
              >
                <Close />
              </IconButton>
            </DialogTitle>
            <DialogContent sx={{ p: 3 }}>
              <Box sx={{ mb: 4, mt: 3 }}>
                <Typography variant="h6" sx={{ mb: 2, color: '#1a237e', fontWeight: 'bold' }}>
                  Monthly Overview - {selectedMonthFormatted}
                </Typography>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                  <Grid item xs={12} sm={6} md={3}>
                    <Paper sx={{
                      p: 2,
                      textAlign: 'center',
                      background: 'linear-gradient(135deg, #4caf50 0%, #81c784 100%)',
                      color: 'white',
                      borderRadius: '8px',
                      boxShadow: '0 4px 12px rgba(76, 175, 80, 0.2)'
                    }}>
                      <CheckCircle sx={{ color: 'white', fontSize: 32, mb: 1, opacity: 0.9 }} />
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold' }}>
                        {monthlyOverview.present}
                      </Typography>
                      <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>
                        Present Days
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={3}>
                    <Paper sx={{
                      p: 2,
                      textAlign: 'center',
                      background: 'linear-gradient(135deg, #f44336 0%, #e57373 100%)',
                      color: 'white',
                      borderRadius: '8px',
                      boxShadow: '0 4px 12px rgba(244, 67, 54, 0.2)'
                    }}>
                      <Cancel sx={{ color: 'white', fontSize: 32, mb: 1, opacity: 0.9 }} />
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold' }}>
                        {monthlyOverview.absent}
                      </Typography>
                      <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>
                        Absent Days
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={3}>
                    <Paper sx={{
                      p: 2,
                      textAlign: 'center',
                      background: 'linear-gradient(135deg, #ff9800 0%, #ffb74d 100%)',
                      color: 'white',
                      borderRadius: '8px',
                      boxShadow: '0 4px 12px rgba(255, 152, 0, 0.2)'
                    }}>
                      <Timer sx={{ color: 'white', fontSize: 32, mb: 1, opacity: 0.9 }} />
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold' }}>
                        {monthlyOverview.late}
                      </Typography>
                      <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>
                        Late Days
                      </Typography>
                    </Paper>
                  </Grid>
                  <Grid item xs={3}>
                    <Paper sx={{
                      p: 2,
                      textAlign: 'center',
                      background: 'linear-gradient(135deg, #9c27b0 0%, #ab47bc 100%)',
                      color: 'white',
                      borderRadius: '8px',
                      boxShadow: '0 4px 12px rgba(156, 39, 176, 0.2)'
                    }}>
                      <AlarmOff sx={{ color: 'white', fontSize: 32, mb: 1, opacity: 0.9 }} />
                      <Typography variant="h6" sx={{ color: 'white', fontWeight: 'bold' }}>
                        {monthlyOverview.leave}
                      </Typography>
                      <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>
                        Leave Days
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>
              </Box>
              <Box sx={{ mb: 4 }}>
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  mb: 2
                }}>
                  <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Event color="primary" sx={{ mr: 1.5 }} />
                    <Typography variant="subtitle1" fontWeight="medium">
                      Monthly Calendar View
                    </Typography>
                  </Box>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <FormControl variant="outlined" sx={{ minWidth: 200, mr: 2 }}>
                      <InputLabel id="status-filter-label">Filter by Status</InputLabel>
                      <Select
                        labelId="status-filter-label"
                        id="status-filter"
                        value={selectedStatus}
                        onChange={handleStatusChange}
                        label="Filter by Status"
                      >
                        {statusOptions.map((option) => (
                          <MenuItem key={option.value} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <Typography variant="body2" color="text.secondary">
                      {selectedMonthFormatted} {selectedDate.year()}
                    </Typography>
                    <IconButton
                      size="small"
                      onClick={() => setSelectedDate(prevDate => prevDate.subtract(1, 'month'))}
                      sx={{
                        bgcolor: alpha('#1a237e', 0.1),
                        '&:hover': { bgcolor: alpha('#1a237e', 0.2) },
                        '&.Mui-disabled': { opacity: 0.5 }
                      }}
                    >
                      <KeyboardArrowLeft fontSize="small" />
                    </IconButton>
                    <IconButton
                      size="small"
                      onClick={() => {
                        const nextMonth = selectedDate.add(1, 'month');
                        if (nextMonth.isBefore(dayjs().add(1, 'month'))) {
                          setSelectedDate(nextMonth);
                        }
                      }}
                      disabled={selectedDate.add(1, 'month').isAfter(dayjs(), 'month')}
                      sx={{
                        bgcolor: alpha('#1a237e', 0.1),
                        '&:hover': { bgcolor: alpha('#1a237e', 0.2) },
                        '&.Mui-disabled': { opacity: 0.5 }
                      }}
                    >
                      <KeyboardArrowRight fontSize="small" />
                    </IconButton>
                  </Box>
                </Box>
                <Paper
                  elevation={0}
                  sx={{
                    p: 3,
                    border: '1px solid rgba(0, 0, 0, 0.12)',
                    borderRadius: 2,
                    background: '#ffffff',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.05)'
                  }}
                >
                  <Grid container spacing={1} sx={{ mb: 2 }}>
                    {['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].map(day => (
                      <Grid item xs={12 / 7} key={day}>
                        <Box
                          sx={{
                            textAlign: 'center',
                            fontWeight: 'bold',
                            p: 1,
                            color: day === 'Sun' || day === 'Sat' ? 'text.secondary' : 'text.primary',
                            borderBottom: '1px solid rgba(0, 0, 0, 0.06)'
                          }}
                        >
                          {day}
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                  <Grid container spacing={1}>
                    {(() => {
                      const firstDayOfMonth = selectedDate.startOf('month');
                      const daysInMonth = selectedDate.daysInMonth();
                      const startingDayOfWeek = firstDayOfMonth.day();
                      const calendarCells = [];

                      // Empty cells for days before the 1st of the month
                      for (let i = 0; i < startingDayOfWeek; i++) {
                        calendarCells.push(
                          <Grid item xs={12 / 7} key={`empty-${i}`}>
                            <Box
                              sx={{
                                height: 100,
                                opacity: 0.3,
                                bgcolor: alpha('#f5f5f5', 0.3),
                                borderRadius: 1
                              }}
                            />
                          </Grid>
                        );
                      }

                      // Days of the month
                      for (let day = 1; day <= daysInMonth; day++) {
                        const currentDate = selectedDate.date(day);
                        const dateString = currentDate.format('D');
                        const dayRecord = monthlyAttendance[dateString];

                        const isDayHoliday = holidays.some(holiday => {
                          const holidayDate = dayjs(holiday.date);
                          return holidayDate.date() === day &&
                            holidayDate.month() === selectedDate.month() &&
                            holidayDate.year() === selectedDate.year();
                        });


                        const holidayInfo = isDayHoliday ?
                          holidays.find(h => {
                            const holidayDate = dayjs(h.date);
                            return holidayDate.date() === day &&
                              holidayDate.month() === selectedDate.month() &&
                              holidayDate.year() === selectedDate.year();
                          }) : null;

                        if (selectedStatus && dayRecord && dayRecord.status?.toLowerCase() !== selectedStatus.toLowerCase() &&
                          !(selectedStatus.toLowerCase() === 'holiday' && isDayHoliday)) {
                          calendarCells.push(
                            <Grid item xs={12 / 7} key={`day-${day}`}>
                              <Box
                                sx={{
                                  minHeight: { xs: 80, sm: 100 },
                                  opacity: 0.3,
                                  bgcolor: alpha('#f5f5f5', 0.3),
                                  borderRadius: 1,
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}
                              >
                                <Typography variant="body2">{day}</Typography>
                              </Box>
                            </Grid>
                          );
                          continue;
                        }

                        const status = dayRecord?.status;
                        const statusColor = status ? getStatusColor(status) : (isDayHoliday ? '#9c27b0' : null);
                        const statusLabel = status ? formatStatus(status) : (isDayHoliday ? 'Holiday' : null);

                        calendarCells.push(
                          <Grid item xs={12 / 7} key={`day-${day}`}>
                            <Tooltip
                              title={dayRecord ?
                                `${statusLabel}: In: ${dayRecord.inTime || '--:--'}, Out: ${dayRecord.outTime || '--:--'}` :
                                (isDayHoliday ? `Holiday: ${holidayInfo?.holiday_name || 'Holiday'}` : '')}
                              arrow
                            >
                              <Box
                                sx={{
                                  minHeight: { xs: 80, sm: 100 },
                                  display: 'flex',
                                  flexDirection: 'column',
                                  borderRadius: 1,
                                  border: (dayRecord || isDayHoliday) ? `1px solid ${alpha(statusColor, 0.3)}` : '1px solid rgba(0, 0, 0, 0.12)',
                                  bgcolor: (dayRecord || isDayHoliday) ? alpha(statusColor, 0.1) : 'transparent',
                                  position: 'relative',
                                  cursor: (dayRecord || isDayHoliday) ? 'pointer' : 'default',
                                  transition: 'all 0.2s',
                                  '&:hover': {
                                    transform: (dayRecord || isDayHoliday) ? 'translateY(-2px)' : 'none',
                                    boxShadow: (dayRecord || isDayHoliday) ? '0 4px 8px rgba(0,0,0,0.1)' : 'none',
                                    bgcolor: (dayRecord || isDayHoliday) ? alpha(statusColor, 0.2) : alpha('#f5f5f5', 0.1)
                                  },
                                }}
                              >
                                <Box sx={{
                                  p: 1,
                                  display: 'flex',
                                  justifyContent: 'space-between',
                                  alignItems: 'center',
                                  borderBottom: (dayRecord || isDayHoliday) ? `1px dashed ${alpha(statusColor, 0.3)}` : 'none'
                                }}>
                                  <Typography
                                    variant="body2"
                                    fontWeight={day === dayjs().date() &&
                                      selectedDate.month() === dayjs().month() &&
                                      selectedDate.year() === dayjs().year() ? 'bold' : 'medium'}
                                    sx={{
                                      color: (dayRecord || isDayHoliday) ? statusColor : 'inherit',
                                      bgcolor: day === dayjs().date() &&
                                        selectedDate.month() === dayjs().month() &&
                                        selectedDate.year() === dayjs().year() ?
                                        alpha('#1a237e', 0.1) : 'transparent',
                                      borderRadius: '50%',
                                      width: 24,
                                      height: 24,
                                      display: 'flex',
                                      alignItems: 'center',
                                      justifyContent: 'center'
                                    }}
                                  >
                                    {day}
                                  </Typography>

                                  {isDayHoliday ? (
                                    <Event fontSize="small" sx={{ color: statusColor }} />
                                  ) : (
                                    dayRecord && status && (
                                      status.toLowerCase() === 'present' ? <CheckCircle fontSize="small" sx={{ color: statusColor }} /> :
                                        status.toLowerCase() === 'absent' ? <Cancel fontSize="small" sx={{ color: statusColor }} /> :
                                          status.toLowerCase() === 'latearrival' ? <Timer fontSize="small" sx={{ color: statusColor }} /> :
                                            status.toLowerCase() === 'leave' ? <AlarmOff fontSize="small" sx={{ color: statusColor }} /> :
                                              <Event fontSize="small" sx={{ color: statusColor }} />
                                    )
                                  )}
                                </Box>

                                {(dayRecord || isDayHoliday) && (
                                  <>
                                    <Box sx={{ px: 1, pt: 1 }}>
                                      <Chip
                                        label={isDayHoliday ?
                                          (holidayInfo?.holiday_name || 'Holiday') :
                                          statusLabel}
                                        size="small"
                                        sx={{
                                          height: 20,
                                          fontSize: '0.65rem',
                                          backgroundColor: alpha(statusColor, 0.2),
                                          color: statusColor,
                                          fontWeight: 'medium',
                                          '& .MuiChip-label': { px: 1 }
                                        }}
                                      />
                                    </Box>

                                    {dayRecord && !isDayHoliday && (
                                      <Box sx={{
                                        px: 1,
                                        mt: 'auto',
                                        pb: 1,
                                        display: 'flex',
                                        flexDirection: {
                                          '@media (max-width:1350px)': 'column',
                                          lg: 'row'
                                        },
                                        flexWrap: {
                                          xs: 'wrap',
                                          '@media (max-width:1350px)': 'nowrap',
                                        },
                                        alignItems: {
                                          xs: 'flex-start',
                                          sm: 'flex-start',
                                        },
                                        gap: {
                                          xs: 0.5,
                                          '@media (min-width:1360px) and (max-width:1399px)': 0,
                                          '@media (min-width:1600px)': 4,
                                        },
                                        justifyContent: {
                                          xs: 'flex-start',
                                          xl: 'space-between'
                                        },
                                        width: {
                                          xl: '90%',
                                          lg: '100%'
                                        }
                                      }}>
                                        {dayRecord.inTime && dayRecord.inTime !== '--:--' && (
                                          <Chip
                                            icon={
                                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                {dayRecord.inOffice ?
                                                  <LocationOn sx={{ fontSize: { xs: '0.5rem', sm: '0.6rem' }, color: '#4caf50' }} /> :
                                                  <LocationOff sx={{ fontSize: { xs: '0.5rem', sm: '0.6rem' }, color: '#f44336' }} />
                                                }
                                                <Alarm sx={{ fontSize: { xs: '0.5rem', sm: '0.6rem' }, color: '#4caf50' }} />
                                              </Box>
                                            }
                                            label={dayRecord.inTime}
                                            size="small"
                                            variant="outlined"
                                            sx={{
                                              height: { xs: 16, sm: 18 },
                                              p: { xs: '1px', sm: '2px' },
                                              fontSize: { xs: '0.55rem', sm: '0.65rem' },
                                              backgroundColor: alpha('#4caf50', 0.1),
                                              borderColor: alpha('#4caf50', 0.3),
                                              color: '#4caf50',
                                              '& .MuiChip-label': { px: { xs: 0.3, sm: 0.5 }, fontWeight: 'medium' },
                                              '& .MuiChip-icon': { mr: { xs: 0, sm: 0.1 }, ml: { xs: 0.2, sm: 0 } },
                                              '&:hover': {
                                                backgroundColor: alpha('#4caf50', 0.15),
                                                borderColor: alpha('#4caf50', 0.4)
                                              }
                                            }}
                                          />
                                        )}

                                        {dayRecord.outTime && (
                                          <Chip
                                            icon={
                                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                                {dayRecord.outOffice ?
                                                  <LocationOn sx={{ fontSize: { xs: '0.5rem', sm: '0.6rem' }, color: '#4caf50' }} /> :
                                                  <LocationOff sx={{ fontSize: { xs: '0.5rem', sm: '0.6rem' }, color: '#f44336' }} />
                                                }
                                                <AlarmOff sx={{ fontSize: { xs: '0.5rem', sm: '0.6rem' }, color: '#f44336' }} />
                                              </Box>
                                            }
                                            label={dayRecord.outTime}
                                            size="small"
                                            variant="outlined"
                                            sx={{
                                              height: { xs: 16, sm: 18 },
                                              fontSize: { xs: '0.55rem', sm: '0.65rem' },
                                              backgroundColor: alpha('#f44336', 0.1),
                                              borderColor: alpha('#f44336', 0.3),
                                              color: '#f44336',
                                              '& .MuiChip-label': { px: { xs: 0.3, sm: 0.5 }, fontWeight: 'medium' },
                                              '& .MuiChip-icon': { mr: { xs: 0, sm: 0.1 }, ml: { xs: 0.2, sm: 0.1 } },
                                              '&:hover': {
                                                backgroundColor: alpha('#f44336', 0.15),
                                                borderColor: alpha('#f44336', 0.4)
                                              }
                                            }}
                                          />
                                        )}
                                      </Box>
                                    )}
                                  </>
                                )}
                              </Box>
                            </Tooltip>
                          </Grid>
                        );
                      }

                      // Empty cells after the last day of the month
                      const totalCells = Math.ceil((daysInMonth + startingDayOfWeek) / 7) * 7;
                      const remainingCells = totalCells - (daysInMonth + startingDayOfWeek);
                      for (let i = 0; i < remainingCells; i++) {
                        calendarCells.push(
                          <Grid item xs={12 / 7} key={`empty-end-${i}`}>
                            <Box
                              sx={{
                                height: 100,
                                opacity: 0.3,
                                bgcolor: alpha('#f5f5f5', 0.3),
                                borderRadius: 1
                              }}
                            />
                          </Grid>
                        );
                      }

                      return calendarCells;
                    })()}
                  </Grid>
                  <Box sx={{ mt: 3, display: 'flex', flexWrap: 'wrap', gap: 2, justifyContent: 'center' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: '#4caf50', mr: 1 }} />
                      <Typography variant="caption">Present</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: '#f44336', mr: 1 }} />
                      <Typography variant="caption">Absent</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: '#ff9800', mr: 1 }} />
                      <Typography variant="caption">Late</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: '#2196f3', mr: 1 }} />
                      <Typography variant="caption">Leave</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: '#9e9e9e', mr: 1 }} />
                      <Typography variant="caption">Weekend</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <LocationOn sx={{ fontSize: '0.8rem', color: '#4caf50', mr: 0.5 }} />
                      <Typography variant="caption">In Office</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <LocationOff sx={{ fontSize: '0.8rem', color: '#f44336', mr: 0.5 }} />
                      <Typography variant="caption">Remote</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                      <Box sx={{ width: 12, height: 12, borderRadius: '50%', bgcolor: '#9c27b0', mr: 1 }} />
                      <Typography variant="caption">Holiday</Typography>
                    </Box>
                  </Box>
                </Paper>
              </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2, background: '#f5f5f5' }}>
              <Button
                onClick={() => setOpenDialog(false)}
                variant="contained"
                sx={{
                  background: 'linear-gradient(135deg, #1a237e 0%, #0d47a1 100%)',
                  '&:hover': {
                    background: 'linear-gradient(135deg, #0d47a1 0%, #1a237e 100%)'
                  }
                }}
              >
                Close
              </Button>
            </DialogActions>
          </>
        )}
      </Dialog>
      <Modal
        open={isMyAttendanceopen}
        onClose={handleMyAttendanceButtonClose}
        aria-labelledby="my-attendance-modal"
        aria-describedby="display-employee-attendance-calendar"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          maxWidth: 1200,
          bgcolor: 'background.paper',
          border: '2px solid #000',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          overflowY: 'auto',
          maxHeight: '90vh',
          position: 'relative'
        }}>
          <IconButton
            onClick={handleMyAttendanceButtonClose}
            sx={{
              position: 'absolute',
              top: '8px',
              right: '8px',
              bgcolor: '#E0E0E0',
              '&:hover': {
                bgcolor: '#CCCCCC',
                transform: 'scale(1.1)'
              },
              transition: 'all 0.2s',
              zIndex: 1000
            }}
          >
            <Close fontSize="small" />
          </IconButton>

          <EmployeeAttendanceCalendar userId={userId} />
        </Box>
      </Modal>
      <Modal
        open={openTokenExpirePopup}
        onClose={handleCloseTokenExpirePopup}
        aria-labelledby="token-expire-modal-title"
        aria-describedby="token-expire-modal-description"
      >
        <TokenExpirePopup onClose={handleCloseTokenExpirePopup} />
      </Modal>
    </Box>
  );
};

export default AttendancePage;